import { render, staticRenderFns } from "./ReferralEarnings.vue?vue&type=template&id=8ac91556&"
import script from "./ReferralEarnings.vue?vue&type=script&lang=js&"
export * from "./ReferralEarnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports